<app-three-column-template
  [pageData]="pageData"
  [showLoader]="true"
  [showTags]="false"
  [hasCustomMain]="true"
  [hasCustomTitle]="true">

  @if (!(isMobileVersion | async)) {
    <ng-container slot="left-section">
      @if (pageData && isCategoriesShown) {
        <app-categories [availableItems]="pageData.itemsCount" [showMobileCategories]="false"></app-categories>
      }
    </ng-container>
  }

  <div class="title-section" slot="custom-title">
    <div class="item-title">
      <span (click)="goBack()"
            class="back icon-CaretLeft"></span>{{ 'Related items'|translate }}
    </div>
    @if (pageData) {
      <div class="item-subtitle">
        {{ 'Explore more news articles related to'|translate }} “<span
        class="item-subtitle-title">{{ pageData.title }}</span>”
      </div>
      <div class="item-count">{{ pageData.relatedItems.totalCount }} {{ 'items found'|translate }}</div>
      @if (isMobileVersion | async) {
        <app-categories [availableItems]="pageData.itemsCount" [showMobileCategories]="true"></app-categories>
      }
    }
  </div>



  @for (relatedItem of relatedItems; track relatedItem.id; let isLast = $last) {
    <app-related-item
      [relatedItem]="relatedItem"
      [isLast]="isLast"></app-related-item>
  }

  @if (pageData && pageData.relatedItems) {
    <app-paginator
      [totalRecords]="pageData.relatedItems.totalCount || 0"
      slot="pagination"></app-paginator>
  }

  @if (isCategoriesShown) {
    <div class="tag-items" slot=right-section>
      @if (pageData && pageData.tags) {
        @for (tag of pageData.tags; track tag.id) {
          <app-tag-item
            [tag]="tag"
            [tagTitle]="tag.name"></app-tag-item>
        }
      }
    </div>
  }
</app-three-column-template>
